import { API } from '../Api';

export const fetchAccountAppCcuApi = () => {
  return new Promise<number>((resolve, reject) => {
    API.get<number>('/account/app-ccu')
      .then((response) => resolve(response.data || 0))
      .catch(reject);
  });
};
export const createAmount = (amount: number) => {
  return new Promise<any>((resolve, reject) => {
    API.post<any>('/v1/payment-service/vnpay/create-payment-url', { amount })
      .then((response) => resolve(response.data || 0))
      .catch(reject);
  });
};
export const fetchBalance = () => {
  return new Promise<any>((resolve, reject) => {
    API.get<any>('/v1/payment-service/users/balance')
      .then((response) => resolve(response.data || 0))
      .catch(reject);
  });
};
export const fetchTransactionHistory = (pageNumber = 1, pageSize = 10000) => {
  return new Promise<any>((resolve, reject) => {
    API.get<any>(`/v1/payment-service/users/transaction-history?pageNumber=${pageNumber}&pageSize=${pageSize}`)
      .then((response) => resolve(response.data || 0))
      .catch(reject);
  });
};
